import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DropdownToggle, DropdownMenu, Container, Input, Label } from "reactstrap";
import CustomSelect from "../../../Components/Common/CustomSelect";
import ClearAllFilters from '../../../Components/Common/ClearAllFilters';
import CustomRadioCheck from '../../../Components/Common/CustomRadioCheck';
import { createSelector } from 'reselect';
import { getAllLibrariesSuccess, resetFilter, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage, setFilter } from '../../../slices/campaigns/reducer';
import country from '../../../common/country';
import { getCampaigns } from '../../../slices/campaigns/thunk';
import { setMarketPath } from '../../../slices/auth/menu/thunk';
import { resetTableFilter } from '../../../slices/folder/thunk';

function Filter() {
  const dispatch = useDispatch();
  const [filterDropdown, setFilterDropdown] = useState(false);
  const selectMenuData = createSelector(state => state.MenuData, state => ({
    menuData: state.client,
    clientPath: state.clientPath,
    brandPath: state.brandPath
  }));
  const { menuData, clientPath, brandPath } = useSelector(selectMenuData);
  // Filter State
  const selectFilterState = createSelector(state => state.Campaign, state => ({
    campaignUsers: state.campaignUsers,
    filterState: state.filter,
    publish: state.filter.publish,
    user: state.filter.user,
    market: state.filter.market,
    sizes: state.filter.sizes
  }));
  const { campaignUsers, filterState, publish, user, market, sizes } = useSelector(selectFilterState);
  // Custom-Select Current Value Holder 
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedSize, setSelectedSize] = useState({});
  const [marketOptions, setMarketOptions] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState({});

  function toggleFilterDropdown() {
    setFilterDropdown(!filterDropdown);
  }

  async function handlePublish(e) {
    dispatch(setFilter({ ...filterState, publish: e.target.value }));
    dispatch(resetTableFilter());
    dispatch(setAllLibrariesFirstLoad(false));
    const res = await dispatch(getCampaigns());
    dispatch(getAllLibrariesSuccess(res.payload));
  }

  async function handleUserSelect(value) {
    dispatch(setFilter({ ...filterState, user: value }));
    dispatch(resetTableFilter());
    dispatch(setAllLibrariesFirstLoad(false));
    const res = await dispatch(getCampaigns());
    dispatch(getAllLibrariesSuccess(res.payload));
  }

  useEffect(() => {
    if (campaignUsers !== null) {
      const foundUser = campaignUsers.find(searchUser => searchUser._id === user);
      if (foundUser) {
        setSelectedUser({ name: foundUser.firstName + " " + foundUser.lastName, value: foundUser._id });
      }
    }
  }, [campaignUsers, user]);

  useEffect(() => {
    if (menuData !== null) {
      const foundClient = menuData.clients.find(client => client._id === clientPath);
      if (foundClient) {
        const foundBrand = foundClient.brands.find(brand => brand._id === brandPath);
        if (foundBrand) {
          setMarketOptions(foundBrand.markets.map(market => {
            return {
              name: market.name,
              value: market._id,
              flagImg: country.find(country => country.name === market.name).flagImg
            }
          }));
        }
      }
    }
  }, [menuData, brandPath]);

  useEffect(() => {
    if (marketOptions.length > 0) {
      const foundMarket = marketOptions.find(searchMarket => searchMarket.value === market);
      if (foundMarket) {
        setSelectedMarket({
          name: foundMarket.name,
          value: foundMarket.value,
          flagImg: country.find(country => country.name === foundMarket.name).flagImg
        });
      }
    }
  }, [marketOptions, market]);

  async function clearFilter() {
    dispatch(resetFilter());
    setSelectedUser({});
    setSelectedSize({});
    setSelectedMarket({});
    dispatch(resetTableFilter());
    dispatch(setAllLibrariesFirstLoad(false));
    setFilterDropdown(false);
    const res = await dispatch(getCampaigns());
    dispatch(getAllLibrariesSuccess(res.payload));
  }

  async function handleMarketSelect(id) {
    await dispatch(setMarketPath(id));
    dispatch(resetTableFilter());
    dispatch(setAllLibrariesFirstLoad(false));
    const res = await dispatch(getCampaigns());
    dispatch(getAllLibrariesSuccess(res.payload));
  }

  return (
    <Dropdown isOpen={filterDropdown} toggle={toggleFilterDropdown}>
      <DropdownToggle tag="button" className="btn bg-primary border-0 px-4 btn btn-secondary">
        <i className="ri-equalizer-fill me-1 align-bottom"></i>
        Filters
      </DropdownToggle>
      <DropdownMenu className='dropdown-menu-lg'>
        <Container className='d-flex flex-column gap-2 py-4' fluid>
          <div className='d-flex flex-row gap-2'>
            <CustomRadioCheck color='success' text="Published" name="publish" value="1" checked={publish === "1"} onChange={handlePublish} />
            <CustomRadioCheck color='warning' text="Draft" name="publish" value="0" checked={publish === "0"} onChange={handlePublish} />
          </div>
          <CustomSelect
            placeholder='Users'
            options={(campaignUsers || []).map(user => { return { name: user.firstName + " " + user.lastName, value: user._id } })}
            onChange={(item) => handleUserSelect(item.value)}
            value={(selectedUser?.name || '')}
          />
          <CustomSelect
            placeholder='Markets'
            options={marketOptions}
            onChange={(item) => handleMarketSelect(item.value)}
            value={(selectedMarket?.name || '')}
          />
          <ClearAllFilters onClick={clearFilter} />
        </Container>
      </DropdownMenu>
    </Dropdown>
  )
}

export default Filter
